import { Box, TextField } from '@mui/material';
import { styled } from '@mui/material/styles';

import { COLORS } from '../../../../../configs/colors';

export const FiltersContainer = styled(Box)({
  padding: '16px 20px 12px',
});

export const SearchField = styled(TextField)({
  '& .MuiOutlinedInput-root': {
    background: COLORS.White,
    borderRadius: '12px',
    boxShadow: '0 1px 4px rgba(0, 0, 0, 0.06)',
    '& fieldset': {
      border: 'none',
    },
    '&:hover fieldset': {
      border: 'none',
    },
    '&.Mui-focused fieldset': {
      border: 'none',
    },
  },
  '& .MuiOutlinedInput-input': {
    fontSize: '0.85rem',
    padding: '10px 16px',
  },
  '& .MuiInputAdornment-root svg': {
    color: COLORS.LightGrey,
    fontSize: '18px',
  },
});
